import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { isNotEmpty } from "../../Utils";

function Form091SubmittedDialog({ formOpen, onConfirm, referenceNumber = "" }) {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <Dialog aria-labelledby="simple-dialog-title" open={formOpen}>
                <DialogTitle id="simple-dialog-title">
                    {t("Form091.dialog.title")}
                </DialogTitle>
                <DialogContent>
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: t("Form091.dialog.content"),
                        }}
                    ></Typography>
                    <br />
                    {isNotEmpty(referenceNumber) &&
                        `${t(
                            "common.portal.referenceNum"
                        )}: ${referenceNumber}`}
                    <br />
                </DialogContent>
                <DialogActions>
                    <Button autoFocus onClick={onConfirm} color="success">
                        <b>{t("common.portal.close")}</b>
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
export default Form091SubmittedDialog;
